export default __webpack_public_path__ + "static/media/Chat.99482262.png";